import { adminCall, adminRequest } from '../../api/adminCall';
import { apiRequest } from '../../../api/client';

export async function requestAdminMagicLink({ email, challengeId }) {
  const data = await adminCall('/api/admin/auth/magic-link/request', { email, challengeId });
  if (!data?.success) {
    throw new Error(data?.error || 'Failed to send login link');
  }
  return data;
}

export async function consumeAdminMagicLink({ token }) {
  const data = await apiRequest('/api/admin/auth/magic-link/consume', {
    method: 'POST',
    body: { token },
  });
  if (!data?.success) {
    throw new Error(data?.error || 'Failed to verify login link');
  }
  return data;
}

export async function requestAdminSmsCode({ email, challengeId }) {
  return adminRequest('/api/admin/auth/sms/request', {
    method: 'POST',
    body: { email, challengeId },
  });
}

export async function consumeAdminSmsCode({ challengeId, code }) {
  const data = await adminCall('/api/admin/auth/sms/consume', { challengeId, code });
  if (!data?.success) {
    throw new Error(data?.error || 'Failed to verify login code');
  }
  return data;
}
